import { useState } from 'react';
import { pageRoutes } from 'shared/routes';
import { getCurrentYear } from 'shared/lib/format';
import { getDefaultDateNavigation } from 'app/lib';
import { ManagerLeadsFilter } from 'entities/lead';
import { ManagerAppointmentsFilter } from 'entities/appointment';
import { ManagerSalesFilter } from 'entities/sales';
import { ManagerInvoiceFilters } from 'entities/invoice';

import { LayoutMenu } from './LayoutMenu';
import { ManagerMenuLink } from './ManagerMenuLink';

export function ManagerLayoutMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(true);

  return (
    <LayoutMenu
      isMenuOpen={isMenuOpen}
      setIsMenuOpen={setIsMenuOpen}
      logoClassName="bg-[url('/assets/menu/manager/logo.svg')]"
      smallLogoClassName="bg-[url('/assets/menu/manager/logo-small.svg')]"
      className="bg-slate-800"
    >
      <div className="flex grow flex-col justify-between">
        <div className="mt-29">
          <ManagerMenuLink
            iconName="corporate_fare"
            title="Contractors"
            href={pageRoutes.internal.contractors}
            isSmallSize={!isMenuOpen}
          />
          <ManagerMenuLink
            iconName="campaign"
            title="Campaigns"
            href={pageRoutes.internal.campaigns}
            isSmallSize={!isMenuOpen}
          />
          <ManagerMenuLink
            iconName="workspaces"
            title="Groups"
            href={pageRoutes.internal.groups}
            isSmallSize={!isMenuOpen}
          />
          <ManagerMenuLink
            iconName="join_inner"
            title="Overlapping"
            href={pageRoutes.internal.overlapping}
            isSmallSize={!isMenuOpen}
          />
          <ManagerMenuLink
            iconName="group"
            title="Leads"
            href={pageRoutes.internal.leads}
            search={getDefaultDateNavigation({
              fromKey: ManagerLeadsFilter.from,
              toKey: ManagerLeadsFilter.to,
            })}
            isSmallSize={!isMenuOpen}
          />
          <ManagerMenuLink
            iconName="event_available"
            title="Appointments"
            href={pageRoutes.internal.appointments}
            search={getDefaultDateNavigation({
              fromKey: ManagerAppointmentsFilter.from,
              toKey: ManagerAppointmentsFilter.to,
            })}
            isSmallSize={!isMenuOpen}
          />
          <ManagerMenuLink
            iconName="paid"
            title="Sales"
            href={pageRoutes.internal.sales}
            search={getDefaultDateNavigation({
              fromKey: ManagerSalesFilter.from,
              toKey: ManagerSalesFilter.to,
            })}
            isSmallSize={!isMenuOpen}
          />
          <ManagerMenuLink
            iconName="receipt"
            title="Invoices"
            href={pageRoutes.internal.invoices}
            search={getDefaultDateNavigation({
              fromKey: ManagerInvoiceFilters.from,
              toKey: ManagerInvoiceFilters.to,
            })}
            isSmallSize={!isMenuOpen}
          />
        </div>
        <div className="w-full">
          {isMenuOpen ? (
            <div className="pb-3 pl-4 pt-13 text-xs font-medium text-slate-500">© {getCurrentYear()} HomeBuddy.</div>
          ) : (
            <div className="ml-[-2px] w-[44px] pb-3 pt-13 text-xs font-medium text-slate-500">© {getCurrentYear()}</div>
          )}
        </div>
      </div>
    </LayoutMenu>
  );
}
